import React from "react";
import { PeekBox, PeekTooltip, useTheme } from "@piiqtechnologies/ui-components";
import { focusRingSx } from "./chartScale";
import { RankingMinMaxLabel } from "./RankingMinMaxLabel";
export const RankingEndLabel = ({ value, caption, tooltipTitle }) => {
    const theme = useTheme();
    return (React.createElement(PeekTooltip, { title: tooltipTitle, placement: "top" },
        React.createElement(PeekBox, { tabIndex: 0, sx: focusRingSx(theme) },
            React.createElement(RankingMinMaxLabel, { value: value, caption: caption }))));
};
export default RankingEndLabel;
